/** saves the channels list in our store
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_channels
*/
export const SAVE_CHANNELS_LIST = (state, payload) => {
    state.channelsList = payload
}

/** update the channels list in our store
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_channels
*/
export const UPDATE_CHANNELS_LIST = (state, payload) => {
    const id = payload.id
    state.channelsList = state.channelsList.map(channel =>
        channel.id === id ? { ...channel, active: payload.state, lastChangeDate: payload.toggleDate } : channel
    )
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.channelsList = []
}
